// extracted by mini-css-extract-plugin
export var container = "_404-module--container--b557a";
export var link = "_404-module--link--35fd2";
export var text = "_404-module--text--280ad";
export var title = "_404-module--title--99db8";